const tintColorLight = '#0a7ea4';
const tintColorDark = '#fff';

export const Colors = {
  light: {
    text: '#11181C',
    background: "#f5f5f5",
    secondaryBackground: "#fff",
    whiteBackground: "#fff",
    borderColor: "#ccc",
    disabledGrey: "#D3D3D3", 
    disabledGreyText: "#A9A9A9",
    grey: "#444",
    lightGrey: "#ececec",
    placeholder: "#7C7A7A",
    transparent: "transparent",
    tint: tintColorLight,
    shadowColor: "#000",
    green: "#009149",
    black: "#333",
    link: "#0a7ea4",
    errorText: "#DD0B0B",
    darkRed: "#911F00",
    icon: '#687076',
    tabIconDefault: '#687076',
    modalOverlay: "rgba(0,0,0,0.5)",
    OpacityGrey: 'rgba(204, 204, 204, 0.8)',
    tabIconSelected: tintColorLight,
    bluePin: "#006ee6",
    radioButton: "blue",
    warningText: "#ff7800",
    lightGreen: "#F1F8F4"

  },
  shadowStyle: { boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.08)' },
  shadowStylePaper: { boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.08)' },
  inputFieldBoxShadow: { boxShadow: 'inset 0px 0px 5px rgba(0, 0, 0, 0.27)' },
  dark: {
    text: '#ECEDEE',
    background: '#151718',
    tint: tintColorDark,
    icon: '#9BA1A6',
    tabIconDefault: '#9BA1A6',
    tabIconSelected: tintColorDark,
  },
};

export const Spacing = {
  padding: 2,
  margin: 2,
  gap: 2,
}

export const Styles = {
  BorderRadius: 6,

};



